import BASEURL from "../config";

function getSafeRedirectFromHash(hash) {
    if (!hash || hash.indexOf("#") !== 0) {
        return null;
    }

    let target;
    try {
        target = decodeURIComponent(hash.substring(1)).trim();
    } catch (err) {
        return null;
    }

    // Only same-origin paths (e.g. #/bookings). Reject garbage and attacker URLs in hash.
    if (!target || target.charAt(0) !== "/") {
        return null;
    }

    const lower = target.toLowerCase();
    if (
        /^(javascript:|data:|vbscript:)/i.test(lower) ||
        /^\/\//.test(target) ||
        /^\/?https?:/i.test(target) ||
        target.indexOf("\\") !== -1 ||
        lower.indexOf("://") !== -1 ||
        target.indexOf("@") !== -1
    ) {
        return null;
    }

    try {
        const baseWithoutHash = window.location.href.split("#")[0];
        const resolved = new URL(target, baseWithoutHash);

        if (resolved.protocol !== "http:" && resolved.protocol !== "https:") {
            return null;
        }
        if (resolved.origin !== window.location.origin || resolved.host !== window.location.host) {
            return null;
        }

        const redirectPath = resolved.pathname + resolved.search;
        if (!redirectPath || redirectPath.indexOf("//") !== -1) {
            return null;
        }

        return redirectPath;
    } catch (err) {
        return null;
    }
}

function handleLocationHash() {
    const hashRedirect = getSafeRedirectFromHash(window.location.hash);
    if (hashRedirect) {
        window.location.replace(hashRedirect);
        return true;
    }
    if (window.location.hash.length > 1) {
        window.location.replace("/");
        return true;
    }
    return false;
}

window.addEventListener("hashchange", handleLocationHash);

var subDomain = window.location.hostname.split(".")[0];
if (!handleLocationHash()) {
    var pathname = window.location.pathname;
    var queryKey = window.location.search;
    var nonSSO = [
        "v2",
        "expense",
        "vendor",
        "localhost",
        "travel",
        "v2-uat",
        "expense-uat",
        "v2-prep",
        "expense-prep",
        "dev-icici-prep-crd",
        "v2-new-ui",
        "segfault1",
        "v2-nui-prep",
        "travel",
        "corptravel",
        "corp-travel",
        "travel-uat",
        "travel-sdx",
        "local"
    ];
    var isSSOLogin = false;
    function getDomainPrefix() {
        let domainPrefix = window.location.hostname.substring(
            window.location.hostname.indexOf(".") + 1
        );
        domainPrefix = domainPrefix.substring(0, domainPrefix.lastIndexOf("."));
        return domainPrefix;
    }

    function _getCookieValue(key) {
        let domainPrefix = getDomainPrefix();
        var name = domainPrefix + "." + key + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    if (
        subDomain &&
        nonSSO.indexOf(subDomain) === -1 &&
        queryKey.indexOf("logout") === -1 &&
        !_getCookieValue("cid")
    ) {
        var url = `${BASEURL}access/v2/sso/?domain=${subDomain}`;
        fetch(url, {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded"
            })
        })
            .then(res => res.json())
            .then(function(dt) {
                debugger;
                var urls = unescape(decodeURIComponent(pathname + queryKey)); // decodeURIComponent(window.location.hash);
                var urlArr = urls ? urls.split("?") : [];

                // filtering the hash key generated due to history
                var queryArr =
                    (urlArr[1] && urlArr[1].split("&").filter(q => !q.startsWith("_"))) || [];

                if (queryArr && queryArr.length && urlArr[1].indexOf("c_code") === -1) {
                    queryArr.splice(queryArr.length, 0, "c_code=+91");
                }

                if (queryArr && queryArr.length && urlArr[1].indexOf("hasRole") === -1) {
                    queryArr.splice(queryArr.length, 0, "hasRole=false");
                }

                var urlObj = {};
                var initialPartOfURL = urlArr[0];
                // var queryPartOfURL = queryArr.join("&");

                if (queryKey.indexOf("user") !== -1 && queryKey.indexOf("userId") !== -1) {
                    for (var key in queryArr) {
                        var tempArray = queryArr[key].split("=");
                        var name = tempArray[0];
                        var value = tempArray[1];

                        if (name == "c_code" && !value) {
                            value = "+91";
                        }
                        if (!urlObj.hasOwnProperty(name)) {
                            urlObj[name] = {};
                        }
                        urlObj[name] = value;
                    }
                }

                if (urlArr && urlArr.length) {
                    var redirectUrl = initialPartOfURL + queryKey;
                    localStorage.setItem("isSSO", true);
                    if (redirectUrl !== "/" && redirectUrl !== "/login") {
                        localStorage.setItem("redirectUrl", redirectUrl);
                        if (urlObj.hasOwnProperty("user") && urlObj.hasOwnProperty("userId")) {
                            localStorage.setItem("urlObj", JSON.stringify(urlObj));
                        }
                    }
                }
                if (dt.redirect_url) {
                    window.location = dt.redirect_url;
                }
            })
            .catch(function(err) {
                console.log(err);
            });
    }
}
